import { AxiosResponse } from "axios";
import axiosInstance from "../apis";
import { firebaseSignIn, firebaseSignOut } from "../firebase";

export const login = (email: string, password: string) =>
  firebaseSignIn(email, password);

export const logout = () => firebaseSignOut();

export const getLinkForUploadImage = (
  fileName: string,
  type: string = "admins"
): Promise<AxiosResponse> => {
  return new Promise((resolve, reject) => {
    const body = {
      fileName,
      type,
    };
    axiosInstance
      .post("image/admin", body)
      .then((res) => resolve(res))
      .catch((e) => reject(e?.response?.data));
  });
};

export const getMeInfo = (): Promise<AxiosResponse> => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get("admin/internal")
      .then((res) => resolve(res))
      .catch((e) => reject(e));
  });
};
